import React from 'react';
import { MessageDescriptorPropType } from '../../../../../prop-types/intl';
import PropTypes from 'prop-types';
import ParameterInputWithLabel from './parameter-input-with-label';
import style from './style.module.less';

const ReportFilters = ({ filtersProps }) => {
  const maxLeftSideControls = 3;
  const hasMoreThenThree = filtersProps.length > maxLeftSideControls;
  const firstThreeInputs = filtersProps.slice(0, hasMoreThenThree ? maxLeftSideControls : filtersProps.length);
  const remainingInputs = hasMoreThenThree ? filtersProps.slice(maxLeftSideControls, filtersProps.length) : undefined;
  return (
    <div className={style.filters}>
      <div className={style['first-three-params']}>
        {firstThreeInputs.map((filterProps, index) => (
          <ParameterInputWithLabel key={index} filterProps={filterProps} />
        ))}
      </div>
      <div className={style['remaining-params']}>
        {hasMoreThenThree && remainingInputs.map((filterProps, index) => <ParameterInputWithLabel key={index} filterProps={filterProps} />)}
      </div>
    </div>
  );
};

ReportFilters.propTypes = {
  filtersProps: PropTypes.arrayOf(
    PropTypes.shape({
      apiKey: PropTypes.string,
      filterType: PropTypes.string,
      label: MessageDescriptorPropType,
      type: PropTypes.string,
    }),
  ).isRequired,
};

export default ReportFilters;
